// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"rates_table_tableContainer__3umZn","noroom":"rates_table_noroom__1_AAx"};